import { Component, OnInit } from '@angular/core';
import { MenuServiceInt } from '@core/_services/menu.serviceint';
import { CommonService } from '@service/common.service';

@Component({
    selector: 'app-nocontent',
    templateUrl: './nocontent.component.html',
    styleUrls: ['./nocontent.component.scss'],
})
export class NocontentComponent implements OnInit {
    constructor(public menu: MenuServiceInt, private commonService: CommonService) {
        this.menu.display = true;
    }

    ngOnInit() {
        this.commonService.checkReset();
    }
}
